import { Component, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "../footer/footer.component";
import { Title } from "@angular/platform-browser";
import { SeoService } from "src/app/services/seo.services";
import { environment } from "src/environment/environment";
import { ApiService } from "src/app/services/api.service";
import { first } from "rxjs";
import { FormsModule } from "@angular/forms";

declare var bootstrap: any;

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, FooterComponent],
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  venueCompanies: any[] = [];
  serviceProviders: any[] = [];
  plan: any;

  plans = [
    {}
  ];


  selectedPlan: any;
  paymentDetails = {
    cardNumber: '',
    expiryDate: '',
    cvv: ''
  };
  selectedFile: File | null = null;

  constructor(
    private ApiService: ApiService
  ) {
    this.venueCompanies = [
      {
        plan_title: 'Free Plan',
        price: 0,
        payment_type: 'Monthly plan',
        description: "",
        features: ['Add 1 Branch', 'Add 1 Hall', 'Add up to 10 menu items', 'Add 2 menu packages', 'Booking through email or contact number']
      },
      {
        plan_title: 'Starter Plan',
        price: 20000,
        payment_type: 'per Month',
        description: "",
        features: ['Add 2 Branch', 'Add 2 Hall per branch', 'Add up to 16 menu items', 'Add 4 menu packages per branch', 'Up to 6 bookings per branch per month (after that, booking through email & contact number)', 'View, accept or reject booking']
      },
      {
        plan_title: 'Standard Plan',
        price: 25000,
        payment_type: 'per Month',
        description: "",
        features: ['Add 3 Branch', 'Add 3 Hall per branch', 'Add up to 25 menu items', 'Add 6 menu packages per branch', 'Up to 10 bookings per branch per month (after that, booking through email & contact number)', 'View, accept or reject & modify booking', 'View reserved order', 'Add up to 5 amenities', 'Add up to 3 vendors', 'Add up to 3 branch managers',]
      },
      {
        plan_title: 'Premium Plan',
        price: 50000,
        payment_type: 'per Month',
        description: "",
        features: ['Add unlimited Branches', 'Add unlimited Hall per branch ', "Add up to unlimited menu items", 'Add unlimited menu packages per branch', 'Unlimited bookings per branch', 'Advance booking features including calendar view, reminders', 'View reserved order', 'Add unlimited amenities', 'Add unlimited vendors', 'Staff Management', 'Customer Management', 'Finance Management', 'Revenue', 'Dashboard Complete Access', 'Ads (10,000 free credit)']
      },
    ];

    this.serviceProviders = [
      // Example data for Service Providers
      {
        plan_title: 'Service Plan A',
        price: 6000,
        payment_type: 'monthly subscription',
        description: "Comprehensive service package",
        features: ['24/7 Support', 'Premium Features']
      },
      {
        plan_title: 'Service Plan B',
        price: 12000,
        payment_type: 'yearly subscription',
        description: "Extended service package",
        features: ['24/7 Support', 'Additional Features']
      }
    ];
  }

  ngOnInit(): void {
    // Initialization logic here
  }

  getPricing(type?: any) {
    if (!!type) {
      let url = new URL(`${environment.baseURL}/api/public/subscription_price_plan/${type}`)
      this.ApiService.get(url.href).pipe(first()).subscribe((response: any) => {
        console.log("resp", response);
        if (type == 'hall_owner') {
          this.venueCompanies = response.data;
        } else if (type == 'vendor') {
          this.serviceProviders = response.data;
        }
      }, (error: any) => {
        // Handle error here
      });
    }
  }

  openPaymentModal(plan: any) {
    this.selectedPlan = plan;
    this.is_process_payment = 0;
    const paymentModal = new bootstrap.Modal(document.getElementById('paymentModal'));
    paymentModal.show();
  }

  is_process_payment: number = 0;
  processPayment() {

    
    // const paymentModal = bootstrap.Modal.getInstance(document.getElementById('paymentModal'));
    // paymentModal.hide();
    
    // const receiptModal = new bootstrap.Modal(document.getElementById('receiptModal'));
    // receiptModal.show();
    this.is_process_payment = 1;
  }




  confirmPayment() {
    this.is_process_payment = 2;
    // const receiptModal = bootstrap.Modal.getInstance(document.getElementById('receiptModal'));
    // receiptModal.hide();
    
    // const confirmationModal = new bootstrap.Modal(document.getElementById('confirmationModal'));
    // confirmationModal.show();
  }
}